import { signatureStyle as signature } from 'now-frontend-shared/styles/signature-styles';
import styles from '../../styles/document-view-styles';

export default {
  inputContainer: {
    ...styles.inputContainer,
    '@media screen and (max-width: 600px)': {
      marginRight: 0,
    },
  },
  dateContainer: {
    ...styles.dateContainer,
    '@media screen and (max-width: 600px)': {
      marginRight: 0,
    },
  },
  signature,
  fieldRow: {
    '@media screen and (max-width: 600px)': {
      width: '100% !important',
      margin: '0 !important',
      '& > .MuiGrid-item': {
        padding: '8px 0 !important',
      },
    },
  },
};
